export default __webpack_public_path__ + "static/media/first_screen_img.9b643eeb.svg";